import { useGetBatchGroupsQuery } from '@/services/payouts';
import { BatchComponent } from '@/types/Payouts';

import { BatchReviewStatus } from 'types';

import { BatchesList } from '../BatchesList';

export const Queued = () => {
  const { data: batches, isLoading: isLoadingBatches } = useGetBatchGroupsQuery({
    batchReviewStatus: BatchReviewStatus.rejected,
  });

  return (
    <>{!isLoadingBatches && batches && <BatchesList batches={batches} originComponent={BatchComponent.queued} />}</>
  );
};
